export const selectContacts = (state) => state.phoneBook.contacts;
export const selectContactsIsLoading = (state) => state.phoneBook.isLoading;
export const selectContactsError = (state) => state.phoneBook.error;
